import WorkInterface from "../interface/work";

const works: WorkInterface[] = [
  {
    title: "workAcacursTitle",
    description: "workAcacursDesciption",
    mockupImages: [
      "./assets/images/mockup/acacurs1.png",
      "./assets/images/mockup/acacurs2.png",
      "./assets/images/mockup/acacurs3.png",
      "./assets/images/mockup/acacurs4.png",
    ],
    playstoreLink: null,
    applestoreLink: null,
    webLink: null,
    presentationLink: null,
    flexDirection: "row",
  },
  {
    title: "Portfolio",
    description: "Abdou Abarchi Aboubacar Portfolio",
    mockupImages: [
      "./assets/images/mockup/portfolio7.png",
    ],
    playstoreLink: null,
    applestoreLink: null,
    webLink: null,
    presentationLink: null,
    flexDirection: "row",
  },
];

export default works;
